import { AlertOctagon, AlertTriangle, CheckCircle2, Eye } from "lucide-react";
import { cn } from "./cn.ts";

export type Risk = "SAFE" | "REVIEW" | "DANGEROUS" | "CRITICAL";

const STYLE: Record<Risk, { icon: typeof Eye; cls: string }> = {
  SAFE: { icon: CheckCircle2, cls: "border-(--saa-border) text-(--saa-fg)" },
  REVIEW: { icon: Eye, cls: "border-(--saa-ring) text-(--saa-fg)" },
  DANGEROUS: { icon: AlertTriangle, cls: "border-amber-500 text-amber-700 dark:text-amber-300" },
  CRITICAL: { icon: AlertOctagon, cls: "border-(--saa-danger) text-(--saa-danger)" },
};

/** Mức rủi ro bằng CHỮ + icon (không chỉ màu — a11y). `label` đã qua i18n (build.risk.*). */
export function RiskBadge({ risk, label, className }: { risk: Risk; label: string; className?: string }) {
  const { icon: Icon, cls } = STYLE[risk];
  return (
    <span data-risk={risk} className={cn("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium", cls, className)}>
      <Icon size={12} aria-hidden />
      {label}
    </span>
  );
}
